// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 224 ? "register" : chunkId) + "." + {"224":"475e5107","405":"ce1a510e","851":"5637ce47"}[chunkId] + ".css";
};